export const getRandomInt = (max) => Math.floor(Math.random() * max);
